import React from "react";
import "../../css/toastView.css";
import Heading from "../../components/Heading";
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import PropTypes from "prop-types";
import ReactPixel from "react-facebook-pixel";
import Link from "gatsby-link";
import Modal from "../../components/Modal";
import Slider from "react-slick";
import "../../components/slick.css";
import "../../components/slick-theme.css";
import LinkedInTag from "react-linkedin-insight";

const icon1 = "https://winpeforum.com/assets/elements/Damodaran.png";
const icon2 = "https://winpeforum.com/assets/elements/Padmini.jpg";
let duration = 400;
 

const I1 = "https://www.winpeforum.com/assets/wob/4dec2025/1.png";
const I2 = "https://www.winpeforum.com/assets/wob/4dec2025/2.png";
const I3 = "https://www.winpeforum.com/assets/wob/4dec2025/3.png";
const I4 = "https://www.winpeforum.com/assets/wob/4dec2025/4.png";
const I5 = "https://www.winpeforum.com/assets/wob/4dec2025/5.png";
const I6 = "https://www.winpeforum.com/assets/wob/4dec2025/6.png";
const I7 = "https://www.winpeforum.com/assets/wob/4dec2025/7.png";
const I8 = "https://www.winpeforum.com/assets/wob/4dec2025/8.png";
const I9 = "https://www.winpeforum.com/assets/wob/4dec2025/9.png";
const I10 = "https://www.winpeforum.com/assets/wob/4dec2025/10.png";
const I11 = "https://www.winpeforum.com/assets/wob/4dec2025/11.png";
const I12 = "https://www.winpeforum.com/assets/wob/4dec2025/12.png";
 

 
 

const II1 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/1.png";
const II2 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/2.png";
const II3 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/3.png";
const II4 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/4.png";
const II5 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/5.png";
const II6 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/6.png";
const II7 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/7.png";
const II8 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/8.png";
const II9 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/9.png";
const II10 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/10.png";
const II11 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/11.png";
const II12 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/12.png"; 
 

const TeamModal = ({ activeItem, show, onHide }) => {
  return (
    <Modal
      direction=""
      className="teamdetails__wrapper"
      show={show}
      onHide={onHide}
    >
      <Modal.Header>
        <div className="head_section">
          <span className="item_name">{activeItem.name}</span>
          <div
            className="item_des"
            dangerouslySetInnerHTML={{ __html: activeItem.post }}
          ></div>
        </div>
        <span className="cross pull-right">
          <i onClick={onHide} className="fa fa-times" />
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className="item__desc">
          <div dangerouslySetInnerHTML={{ __html: activeItem.desc }}></div>
        </div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};

TeamModal.propTypes = {
  activeItem: PropTypes.object,
  show: PropTypes.object,
  onHide: PropTypes.object,
};

export class SheShines extends React.Component {
  constructor(args) {
    super(args);
    this.state = {
      slidesToShow: 1,
      activeItem: {},
      isShow: false,
      defaultStyle: {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0,
      },
    };
     
    this.Speaker1 = [
      
              {
          imgUrl: icon1,
          desc: `<div>
M. Damodaran, IAS (Retd.), presently a governance consultant, advisor, mentor and coach, has worked
with the Union and the State governments in India, regulatory bodies, investment institutions, banks,
development financial institutions and with the private sector. He has headed the highly successful
restructuring efforts in Unit Trust of India (UTI) and Industrial Development Bank of India (IDBI). He has
been the Chairman of Securities and Exchange Board of India (SEBI). During his tenure at SEBI, he was
elected Chairman of the EMC of the International Organisation of Securities Commission (IOSCO).
He has chaired high powered committees of the Government of India, Reserve Bank of India (RBI) and
some chambers of commerce. He has won several awards, including some for governance, leadership
and transformation. He has been on the Boards of some of India’s biggest companies and on the
 
Advisory Boards of some foreign entities and is the Founder Chairman of Indian Institute of Management
(IIM), Tiruchirappalli. He graduated with distinction in Economics and in Law from the Universities of
Madras and Delhi respectively. He is widely acknowledged as one of India’s foremost champions of
Corporate Governance and is passionate about improving Board performance.
 
          </div>`,
          name: "M. Damodaran",
          post: `<div>Founder & Chairperson<br/> Excellence Enablers

          </div>`,
        },
        {
          imgUrl: icon2,
          desc: `<div>
Padmini Khare Kaicker is the Managing Partner of B. K. Khare & Co., one of India’s most respected accounting firms with a six-decade legacy. Under her leadership, the firm has grown into a full-service practice with a strong national presence and a reputation for excellence, ethics, and innovation. A Chartered Accountant (ICAI) and CPA (USA), Padmini brings over 25 years of experience across sectors including Manufacturing, BFSI, Oil & Gas, IT, Hospitality, Real Estate, and Retail. She is widely recognised for her expertise as a Statutory Auditor, Strategic Advisor, and Independent Director.<Br/><Br/>
She currently serves on the boards of NPCI, Tata Chemicals (where she chairs the Audit Committee), Rallis India, Bosch Ltd., and Franklin Templeton Asset Management (IFSC). Her previous board roles include Kotak Mahindra Investments, J. B. Chemicals & Pharmaceuticals, IndusInd Bank, and Gabriel India.



 
          </div>`,
          name: "Ms Padmini Khare Kaicker",
          post: `<div>Managing Partner<br/>
B. K. Khare &amp; Co.



          </div>`,
        },
          
      
    ];

    this.Speaker2 = [
       
      
      {
        imgUrl: icon2,
        desc: `Alka Goel is the Founder of Alkemi Growth Capital LLP, an early stage healthcare and consumer wellness fund. She has led investment in multiple sub-sectors over the last 6 years. Prior to that, Alka was a Partner in McKinsey & Co., New York office, where she primarily served clients in the life science and private equity industry.
<br/><br/>
At McKinsey, she served more than 350 Clients across all major geographies. She completed her business school from Indian Institute of Management, Ahmedabad in 2000 and Bachelor of Economics from Lady Shri Ram College, Delhi University.


         `,
        name: "Alka Goel",
        post: `<div>Founding Partner<br/> Alkemi Growth Capital
        </div>`,
      },

      
    ];
    this.CollegiumsImages = [
      { id:23, ImgSrc: I1, ImgSrc1: II1,},   
      
        { id:35, ImgSrc: I2, ImgSrc1: II2,},   

        { id:22, ImgSrc: I3, ImgSrc1: II3,},   
        { id:19, ImgSrc: I4, ImgSrc1: II4,},  
        { id:35, ImgSrc: I5, ImgSrc1: II5,},   
        { id:34, ImgSrc: I6, ImgSrc1: II6,},  
        { id:23, ImgSrc: I7, ImgSrc1: II7,},   
      
        { id:35, ImgSrc: I8, ImgSrc1: II8,},   

        { id:22, ImgSrc: I9, ImgSrc1: II9,},   
        { id:19, ImgSrc: I10, ImgSrc1: II10,},  
        { id:35, ImgSrc: I11, ImgSrc1: II11,},   
        { id:34, ImgSrc: I12, ImgSrc1: II12,},  
    
    ];
  
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    ReactPixel.init("2879175222167037");
    ReactPixel.track("ViewContent", location);
    LinkedInTag.init("2117884");
    LinkedInTag.track("2310748");
    setTimeout(() => {
      this.setState({
        defaultStyle: {
          transition: `opacity ${duration}ms ease-in-out`,
          opacity: 1,
        },
      });
    }, 500);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    const { slidesToShow } = this.state;
    // // console.log("width", window.innerWidth)
    if (window.innerWidth <= 768 && window.innerWidth > 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else if (window.innerWidth <= 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    }
  };
  togglePopUp = (item) => {
    this.setState({
      isShow: !this.state.isShow,
      activeItem: item || {},
    });
  };
  render() {
    const { defaultStyle, isShow, slidesToShow } = this.state;
    const { location } = this.props;
    let settings = {
      dots: false,
      infinite: true,
      speed: 6000,
      autoplay: true,
      slidesToShow: slidesToShow,
      slidesToScroll: slidesToShow,
      autoplaySpeed: 7000,
      arrows: true,
    };
    console.log("render", this.render1, slidesToShow);
    this.render1 = this.render1 + 1;
    return (
      <ContentPage>
         <Meta
          title="Women on Boards"
          image={"https://winpeforum.com/assets/wob/banner.jpg"}
          description="Winpe’s Women on Boards initiative hosted another exceptional session marked by profound insights, engaging discussions, and inspiring connections. We are pleased to report that the session received outstanding evaluations—100% of participants acknowledged significant knowledge gains, and our speakers were rated exceptionally well at 4.5."
          location={location}
        />
        <div className="section__content" style={defaultStyle}>
          <div className="toastshine_wrapper">
            <div className="back_event">
              <Link to="/events/">
                <i className="fa fa-arrow-left">Back to Events</i>
              </Link>
            </div>
            <div className="toastshine_section">
              <div className="m_heading">Module 2: Financial Oversight and Committee Excellence
  </div>
              <div className="r_btm"></div>
               
 
              <div className="date_heading">
                <div className="date_heading">
                 <span> 
       December 4th, 2025 (10:00 - 5:00 PM IST)<br/>
 Taj Lands End, Mumbai</span>
                </div>
              </div>
              <br/>     
              
              <div className="top_text" style={{textAlign:'justify'}}>
          <b>Winpe’s Women on Boards initiative hosted</b> another exceptional session marked by profound insights, engaging discussions, and inspiring connections. We are pleased to report that the session received outstanding evaluations—100% of participants acknowledged significant knowledge gains, and our speakers were rated exceptionally well at 4.5.<br/><br/>
<b>This immersive, practice-driven programme used case studies and real life examples to illustrate and explain the role and critical importance of Audit, Risk and Nomination & Remuneration Committees in corporate governance, leaving participants equipped with a deeper clarity and understanding.</b><br/><br/>
Video recording of this session is available for participants who attended for more than half the day. You can message on the WoB WhatsApp group or via email to request access. <br/><br/>
Join our WoB community to receive access to board opportunities. Stay updated on upcoming sessions, opportunities, and insights through our WhatsApp group.<br/><br/>

👉 <a style={{textDecoration:'underline', color:'blue'}}  href="https://tally.so/r/wv9OJX">Join our peer community</a>    &nbsp;&nbsp;&nbsp;&nbsp;👉          <a style={{textDecoration:'underline', color:'blue'}}  href="https://chat.whatsapp.com/Jlema24oL2sJ2aDUUFREDa">Join the WhatsApp Group</a>
<br/> <br/>


<br/> 
  


<h3><b>Session Focus</b></h3>
<b >The programme equipped participants to enhance board effectiveness across Audit, Risk and, Nomination & Remuneration committees, focusing on:
</b> 
<ul>
   
    
<li><b>Financial Acumen:</b> Sharpened skills to read and interpret financial statements, identify red flags, and draw actionable insights.</li> 

<li><b>Internal Controls:</b> Techniques to test, identify gaps, and drive focused remediation.
</li> 

<li><b>Risk Oversight:</b> Enhanced capability to challenge risk frameworks, stress-test scenarios, and ensure quality reporting.
</li> 

<li><b>Committee Impact:</b> Frameworks to convert charters into performance-driven agendas.</li> 

<li><b>Governance Excellence:</b> Reinforced principles of transparency, accountability, ethical rigor, and forward-looking oversight.
</li> 

 
</ul>
<br/> 
<p> Winpe’s <i>Women on Boards</i> initiative is redefining boardroom leadership by championing the inclusion of exceptional, board-ready women leaders. In partnership with forward-thinking companies, the initiative opens doors to a hand-picked network of accomplished candidates, robust board-preparedness programs, and strategic engagement models tailored to strengthen governance and fulfill diversity, equity, and inclusion commitments.
 By unlocking the full potential of diverse leadership, <i>Women on Boards</i> is not just transforming boardrooms — it's setting a new standard for business excellence.</p>


    <div className="row"> 
                          

                  <div className="col-md-12">   

                  <h2 class="ignite-ask-me-anything__heading" style={{ fontSize: "30px" }}>Faculty</h2>          <div class="r_btm"></div>
                      
                 
                     
                      <div className="Our_Speakers container">
                                <center>
                                  <div className="Speakers_img" style={{ width: '70%', margin:'0' }}>
                                    <div className="row">
        
                                      {this.Speaker1.map((item, i) => {
                                       if(i<=3) 
                                       {
                                        return (
                                          <div
                                            className="main_speaker_card col-md-6 col-sm-12 col-lg-6"
                                            key={i}
                                          >
                                            <div className="Scardd">
                                              <div
                                                className="s_img"
                                                onClick={() => this.togglePopUp(item)}
                                              >
                                                 <center>  <img
                                                  src={item.imgUrl}
                                                  alt={item.name}
                                                  className="img-responsive"
                                                  style={{ borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }}
                                                />
                                                </center>
                                              </div>
                                              <br />    <div
                                                className="Speakers_name"
                                                dangerouslySetInnerHTML={{ __html: item.name }}
                                              ></div>
                                              <div
                                                className="Speakers_post"
                                                dangerouslySetInnerHTML={{ __html: item.post }}
                                              ></div>
                                            </div>
                                          </div>
                                        );
                                       }
                                       else 
                                       return (
                                          <div
                                            className="main_speaker_card col-md-3 col-sm-12 col-lg-3"
                                            key={i}
                                          >
                                            <div className="Scardd">
                                              <div
                                                className="s_img"
                                                onClick={() => this.togglePopUp(item)}
                                              >
                                                 <center>  <img
                                                  src={item.imgUrl}
                                                  alt={item.name}
                                                  className="img-responsive"
                                                  style={{ borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }}
                                                />
                                                </center>
                                              </div>
                                              <br />    <div
                                                className="Speakers_name"
                                                dangerouslySetInnerHTML={{ __html: item.name }}
                                              ></div>
                                              <div
                                                className="Speakers_post"
                                                dangerouslySetInnerHTML={{ __html: item.post }}
                                              ></div>
                                            </div>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  </div>
        
                                </center>
                              </div>
        </div>
        
                
</div> 



 

              </div>
              
             
              <div className="container">
                    <div>
                      <Heading title="Gallery" />
                    </div>
                    <div className="row">
                      {this.CollegiumsImages.map((item, j) => {
                        return (
                          <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12" style={{padding: '8px'}}>
                            <div className="img_card">
                            <img style={{width:'100%'}} src={item.ImgSrc} alt="Winpe sheshines" />
                            <a href={item.ImgSrc1} > <i style={{color:'white', position:'absolute', left:'20px', top:'20px'}} class="fa fa-2x  fa-download "></i></a> 
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                 <br/>
  <br/> 
   
<div class="container">
<br/>
 
 
 </div>
       
          <br/><br/>
     
            </div>
            <TeamModal
              show={isShow}
              onHide={this.togglePopUp}
              activeItem={this.state.activeItem}
            />
          </div>
        </div>
      </ContentPage>
    );
  }
}

SheShines.propTypes = {
  location: PropTypes.object,
};

export default SheShines;



// WEBPACK FOOTER //
// ./src/pages/WOBModule2EventReport/index.js